import React from "react";

interface StartIconProps {
  className?: string;
  onClick?: () => void;
}

export const StartIcon = ({ className, onClick }: StartIconProps) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M16.5938 0.25C16.9922 0.25 17.3203 0.367187 17.5781 0.601562C17.8594 0.8125 18 1.08203 18 1.41016V12.9062C18 13.4219 17.7305 13.7852 17.1914 13.9961C15.668 14.582 14.2266 14.875 12.8672 14.875C11.9062 14.875 10.6172 14.6758 9 14.2773C7.38281 13.8789 6.09375 13.6797 5.13281 13.6797C3.91406 13.6797 2.57812 13.9375 1.125 14.4531V17.9688C1.125 18.1562 1.03125 18.25 0.84375 18.25H0.28125C0.09375 18.25 0 18.1562 0 17.9688V0.8125C0 0.648437 0.046875 0.519531 0.140625 0.425781C0.257812 0.308594 0.398438 0.25 0.5625 0.25C0.726562 0.25 0.855469 0.308594 0.949219 0.425781C1.06641 0.519531 1.125 0.648437 1.125 0.8125V1.09375C2.71875 0.53125 4.11328 0.25 5.30859 0.25C6.24609 0.25 7.34766 0.460938 8.61328 0.882812C9.90234 1.28125 10.9219 1.48047 11.6719 1.48047C12.8906 1.48047 14.2852 1.12891 15.8555 0.425781C16.1133 0.308594 16.3594 0.25 16.5938 0.25ZM12.8672 13.75C13.4531 13.75 14.0742 13.6914 14.7305 13.5742C15.3867 13.4336 15.9023 13.293 16.2773 13.1523C16.6523 13.0117 16.8516 12.9297 16.875 12.9062V1.62109C16.875 1.52734 16.8164 1.45703 16.6992 1.41016C16.6055 1.36328 16.4766 1.375 16.3125 1.44531C14.6016 2.21875 13.0547 2.60547 11.6719 2.60547C10.8281 2.60547 9.76172 2.40625 8.47266 2.00781C7.18359 1.58594 6.12891 1.375 5.30859 1.375C4.11328 1.375 2.71875 1.66797 1.125 2.25391V13.2227C2.53125 12.7773 3.86719 12.5547 5.13281 12.5547C6.1875 12.5547 7.52344 12.7539 9.14062 13.1523C10.7578 13.5508 12 13.75 12.8672 13.75Z"
      fill="#0344DC"
    />
  </svg>
);

StartIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
